import { useState } from "react"
import styles from "./ProjectDetail.module.css"
import ImageViewer from "../ImageViewer/ImageViewer"
import { translations } from "../../translations"
import { useTranslationUpdate } from "../../hooks/useTranslationUpdate"

type Tech = { name: string; icon: string }
type Tag = { name: string; color: string }

export default function ProjectDetail({
  logo, title, about, technologies, photos, tags, primary = '#a7e0db', secondary = '#43c3b5', link
}: {
  logo: string
  title: string
  about: string
  technologies: Tech[]
  photos: string[]
  tags: Tag[]
  primary?: string
  secondary?: string
  link?: string
}) {
  useTranslationUpdate()
  const grid = photos.slice(0, 9)
  const placeholders = Array.from({ length: Math.max(0, 9 - grid.length) })
  const [viewIndex, setViewIndex] = useState<number | null>(null)

  return (
    <div
      className={styles.wrap}
      style={{
        ['--primary' as any]: primary,
        ['--secondary' as any]: secondary
      }}
    >
      <div className={`${styles.scroll} ${viewIndex !== null ? styles.scrollLock : ""}`}>
        <div className={styles.banner} />
        <div className={styles.header}>
          <div className={styles.avatarWrap}><img src={logo} className={styles.avatar} alt="Project logo" /></div>
          <div className={styles.titleBlock}>
            <h1 className={styles.title}>{title}</h1>
            <div className={styles.tags}>
              {tags.map((t, i) => (
                <span key={i} className={styles.tag} style={{ background: t.color }}>{t.name}</span>
              ))}
            </div>
          </div>
        </div>

        <div className={styles.main}>
          <div className={styles.gallery}>
            {grid.map((src, i) => (
              <div key={i} className={styles.cell} onClick={() => setViewIndex(i)}>
                <img src={src} className={styles.photo} alt={`Project screenshot ${i + 1}`} />
              </div>
            ))}
            {placeholders.map((_, i) => (<div key={`ph-${i}`} className={styles.cell} />))}
          </div>

          <div className={styles.side}>
            <section className={styles.panel}>
              <div className={styles.panelHead}>{translations('projects.about')}</div>
              <div className={styles.panelBody}>{about}</div>
              {link && (
                <a
                href = { link }
    target="_blank"
              rel="noopener noreferrer"
              className={styles.projectLink}
  >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                <polyline points="15 3 21 3 21 9" />
                <line x1="10" y1="14" x2="21" y2="3" />
              </svg>
              {translations('projects.visit_site') || 'Visitar site'}
            </a>
)}
          </section>

          <section className={styles.panel}>
            <div className={styles.panelHead}>{translations('projects.technologies')}</div>
            <div className={styles.panelBody}>
              <ul className={styles.techList}>
                {technologies.map((t, i) => (
                  <li key={i} className={styles.techItem}>
                    <img src={t.icon} className={styles.techIcon} alt="" />
                    <span className={styles.techName}>{t.name}</span>
                  </li>
                ))}
              </ul>
            </div>
          </section>
        </div>
      </div>
    </div>

      {
    viewIndex !== null && (
      <ImageViewer
        items={grid.map(src => ({ src }))}
        index={viewIndex}
        onClose={() => setViewIndex(null)}
      />
    )
  }
    </div >
  )
}